// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container[data-v-304dba90] {\n  margin: 0px 0 60px 0;\n  max-width: 100%;\n}\n.banner_class[data-v-304dba90] {\n  margin-top: 40px;\n}\n@media (max-width: 971px) {\n.banner_class[data-v-304dba90] {\n    margin-top: 0px;\n    margin-bottom: 10px;\n}\n}", ""]);
// Exports
module.exports = exports;
